import React, {Component} from "react"

import id from "@irati/utils/id"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import sagaService from "@irati/deals/services/perks-saga"
import {Product, Deal} from "@irati/types"
import withBasket, {WithBasket} from "@irati/checkout/utils/basket/withBasket"
import {hitLimits} from "@irati/checkout/utils/deal/limits"
import Flex from "@irati/ui/src/Flex"
import {Row, Col} from "@irati/ui/src/ColumnRow"
import {Label} from "@irati/ui/src/Typography"

import QuantityPicker from "./QuantityPicker"
import {Error} from "./styled"
import RewardPrice from "./RewardPrice"

export type QuantityOnChange = (type: "+" | "-", productId: string) => any

interface Props extends WithBasket {
  deal: Deal
  product: Product
  handleClick: QuantityOnChange
}

interface State {
  stockTotals: {[key: string]: number}
  reachedMaxPrice: boolean
  reachedMaxProducts: boolean
  reachedMaxItems: boolean
}

class QuantityItem extends Component<Props, State> {
  static getDerivedStateFromProps(props: Props) {
    const {items} = props.basket
    const {reachedMaxPrice, reachedMaxProducts, reachedMaxItems} = hitLimits(props.deal)
    const igoreThisProductReachedMaxProducts = reachedMaxProducts && !items.find((t) => t.productId === props.product.uuid)

    return {reachedMaxPrice, reachedMaxProducts: igoreThisProductReachedMaxProducts, reachedMaxItems}
  }

  state: State = {
    stockTotals: {},
    reachedMaxPrice: false,
    reachedMaxProducts: false,
    reachedMaxItems: false
  }

  componentDidMount() {
    sagaService.stockCount(this.props.deal.uuid).then(({stockTotals}) => {
      this.setState({stockTotals})
    })
  }

  isOutOfStock = () => {
    const {product, basket} = this.props
    const {stockTotals} = this.state
    const countForProduct = basket.items.find((item) => item.productId === product.uuid)?.count || 0
    return stockTotals[product.uuid] <= countForProduct
  }

  isLowInStock = () => {
    if (this.isOutOfStock()) {
      return false
    }
    const {product} = this.props
    const {stockTotals} = this.state
    return stockTotals[product.uuid] <= 10
  }

  isDisabled = () => {
    const {reachedMaxPrice, reachedMaxProducts, reachedMaxItems} = this.state
    return reachedMaxPrice || reachedMaxProducts || reachedMaxItems || this.isOutOfStock()
  }

  render() {
    const {product, handleClick, basket} = this.props
    const {stockTotals} = this.state
    const countForProduct = basket.items.find((item) => item.productId === product.uuid)?.count || 0
    const {uuid} = product

    return (
      <Row marginBottom={2}>
        <Col xs={12}>
          <Row>
            <Col xs={4}>
              <Row>
                <Col xs={12}>
                  <Label id={id("label", this.props)} large>
                    {product.name}
                  </Label>
                </Col>
                <Col xs={12}>
                  {this.isOutOfStock() && (
                    <Error>
                      <FormattedMessage id="perks.components.quantityItem.outOfStock.error" />
                    </Error>
                  )}
                  {this.isLowInStock() && (
                    <Error style={{color: "grey"}}>
                      <FormattedMessage id="perks.components.quantityItem.stockLeft" values={{count: stockTotals[uuid]}} />
                    </Error>
                  )}
                </Col>
              </Row>
            </Col>
            <Col xs={4}>
              <RewardPrice product={product} />
            </Col>
            <Col xs={4}>
              <Flex justifyContent="flex-end">
                <QuantityPicker
                  id={id("picker", this.props)}
                  className="pull-right"
                  num={countForProduct}
                  onClick={(type: "+" | "-") => handleClick(type, uuid)}
                  disabled={this.isDisabled()}
                  outOfStock={this.isOutOfStock()}
                />
              </Flex>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default injectIntl(withBasket(QuantityItem))
